import hljs from 'highlight.js/lib/core';
import bash from 'highlight.js/lib/languages/bash';
import css from 'highlight.js/lib/languages/css';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import lua from 'highlight.js/lib/languages/lua';
import php from 'highlight.js/lib/languages/php';
import plaintext from 'highlight.js/lib/languages/plaintext';
import sql from 'highlight.js/lib/languages/sql';
import xml from 'highlight.js/lib/languages/xml';

hljs.registerLanguage('bash', bash);
hljs.registerLanguage('css', css);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('json', json);
hljs.registerLanguage('lua', lua);
hljs.registerLanguage('php', php);
hljs.registerLanguage('plaintext', plaintext);
hljs.registerLanguage('sql', sql);
hljs.registerLanguage('xml', xml);

function highlightCodeBlocks(root = document) {
	const codeBlocks = root.matches?.('pre code')
		? [root, ...root.querySelectorAll('pre code')]
		: root.querySelectorAll('pre code');

	codeBlocks.forEach((codeBlock) => {
		if (codeBlock.dataset.highlighted === 'yes') {
			return;
		}

		const language = [...codeBlock.classList]
			.find((className) => className.startsWith('language-'))
			?.slice('language-'.length);

		if (language && !hljs.getLanguage(language)) {
			return;
		}

		hljs.highlightElement(codeBlock);
	});
}

document.addEventListener('DOMContentLoaded', () => {
	highlightCodeBlocks();
});

document.addEventListener('livewire:init', () => {
	highlightCodeBlocks();

	Livewire.hook('morphed', ({el}) => {
		highlightCodeBlocks(el);
	});
});

document.addEventListener('livewire:navigated', () => {
	highlightCodeBlocks();
});
